// var $document = $(document),
//     $element = $('#Left_Nav'),
//     className = 'hasScrolled';

// $document.scroll(function() {
//   $element.toggleClass(className, $document.scrollTop() >= 50);
// });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 529) {
        $(".blog_list.toggle_list").addClass("fixed");
      	$("h2.title.toggle").addClass("oni_hidden");
    } else {
        $(".blog_list.toggle_list").removeClass("fixed");
      	$("h2.title.toggle").removeClass("oni_hidden");
    }
});






